import React, { useCallback, useEffect, useState } from 'react';

import { pausedInvoiceIcon } from '@europrocurement/l2d-icons';
import {
    AchatsAppDispatch,
    CategorieStats,
    CategorieStatsSelector,
    CodeRejetStats,
    CodeRejetStatsSelector,
    FactureAchat,
    FactureachatSelector,
    factureAchatsFiltersToElasticQuery,
    FACTURES_ACHATS_STATS_DATASOURCE_NAME,
    useAchatsService,
    useSociete,
} from '@europrocurement/l2d-domain';
import { DataSource } from '@europrocurement/l2d-redux-utils';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { WidgetWithAction } from '@europrocurement/l2d-modules';
// interne

const FacturesEnERDO5: React.FunctionComponent = function () {
    const dispatch = useDispatch<AchatsAppDispatch>();
    const navigate = useNavigate();

    const xIdSociete = useSociete();

    const { factureAchatApi, getCategorieStats, getCodeRejetStats, getFactureAchatStats } =
        useAchatsService();

    const categoriesDataSource: DataSource<CategorieStats> =
        useSelector(CategorieStatsSelector).main;
    const codesRejetsDataSource: DataSource<CodeRejetStats> =
        useSelector(CodeRejetStatsSelector).main;
    const facturesAchatsDataSource: DataSource<FactureAchat> =
        useSelector(FactureachatSelector)[FACTURES_ACHATS_STATS_DATASOURCE_NAME];

    const [countOfInvoicesAsERDO5, setCountOfInvoicesAsERDO5] = useState<string>();

    const fetchCount = useCallback(() => {
        factureAchatApi
            .getFacturesAchatsFactureAchatCollection(
                factureAchatsFiltersToElasticQuery({
                    xIdSociete,
                    search: '',
                    orders: [],
                    pagination: {
                        page: 0,
                        itemsPerPage: 0,
                    },
                    filters: {
                        cloture: true,
                        deleted: false,
                        codesRejets: ['ERDO5'],
                    },
                }),
            )
            .then((res) => {
                if (
                    res.data['hydra:totalItems'] !== null ||
                    res.data['hydra:totalItems'] !== undefined
                ) {
                    setCountOfInvoicesAsERDO5(`${res.data['hydra:totalItems']}`);
                }
            });
    }, [factureAchatApi, xIdSociete]);

    useEffect(() => {
        fetchCount();
    }, [fetchCount]);

    const clearPreviousFilters = useCallback(() => {
        dispatch({
            type: `${categoriesDataSource.slicename}/resetmainFilter`,
        });
        dispatch({
            type: `${codesRejetsDataSource.slicename}/resetmainFilter`,
        });
        dispatch({
            type: `${facturesAchatsDataSource.slicename}/reset${FACTURES_ACHATS_STATS_DATASOURCE_NAME}Filter`,
        });
    }, [
        categoriesDataSource.slicename,
        codesRejetsDataSource.slicename,
        dispatch,
        facturesAchatsDataSource.slicename,
    ]);

    const applyFilters = useCallback(() => {
        dispatch({
            type: `${categoriesDataSource.slicename}/set${categoriesDataSource.name}Filter`,
            payload: {
                key: 'codesRejets',
                value: ['ERDO5'],
            },
        });
        dispatch({
            type: `${categoriesDataSource.slicename}/set${categoriesDataSource.name}Filter`,
            payload: {
                key: 'idSociete',
                value: xIdSociete,
            },
        });
    }, [dispatch, categoriesDataSource.slicename, categoriesDataSource.name, xIdSociete]);

    const beforeActionCallback = useCallback(() => {
        clearPreviousFilters();
        applyFilters();
    }, [applyFilters, clearPreviousFilters]);

    const actionCallback = useCallback(async () => {
        await Promise.all([
            dispatch(getCategorieStats({})),
            dispatch(getCodeRejetStats({})),
            dispatch(getFactureAchatStats({})),
        ]);
    }, [dispatch, getCategorieStats, getCodeRejetStats, getFactureAchatStats]);

    const onActionSuccessCallback = useCallback(() => {
        console.log('onActionSuccessCallback');
        navigate('/achats/stats?tab=detail');
    }, [navigate]);

    return (
        <WidgetWithAction
            title="Factures en ERDO5"
            icon={pausedInvoiceIcon}
            actionMessage="Consulter"
            actionCallback={actionCallback}
            data={countOfInvoicesAsERDO5}
            color="ERDO"
            loadingMessage="Application des filtres..."
            onRetryData={fetchCount}
            beforeActionCallback={beforeActionCallback}
            onActionSuccessCallback={onActionSuccessCallback}
        />
    );
};

export default FacturesEnERDO5;
